module.exports = __webpack_public_path__ + "static/media/cert_111.4775aeda.jpg";